export const ROUTES = {
  PERFORMANCE: '/performance',
  CREATE_PASSWORD: '/create-password',
} as const

// Pre-auth / credential / handoff / public-legal paths. Blocking modals
// (mandatory assessment, needs analysis, etc.) must not stack on top of
// these flows — doing so hides the action the user came to take. Prefix-
// matched so parametric routes like /accept-invite/:token are covered.
export const GUARD_EXCLUDED_PATH_PREFIXES = [
  ROUTES.CREATE_PASSWORD,
  '/signin',
  '/accept-invite',
  '/reset-password',
  '/auth/',
  '/lti/',
  '/terms-of-use',
  '/privacy-policy',
] as const

export function isGuardExcludedPath(pathname: string): boolean {
  return GUARD_EXCLUDED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}
